import React, { useState } from "react";
import { menuItems as rawMenuItems } from "../../../utils/constants";
import MenuSide from "../../../components/empresas/MenuSide";
import {
  IonItem,
  IonLabel,
  IonContent,
  IonList,
  IonPage,
  IonActionSheet,
} from "@ionic/react";
import HeaderApp from "../../../components/global/HeaderItem";
import { useNavigate } from "react-router-dom";

export default function InicioCustomEmpresa() {
  const navigate = useNavigate();
  const [actionSheetNumero, setActionSheetNumero] = useState(false);

  const logout = () => {
    document.cookie =
      "token_usuario_agendou" +
      "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    localStorage.removeItem("tipoUsuario");
    window.location.href = "/";
  };

  const modalLogout = () => {
   setActionSheetNumero(true);
  };

  const menuItems = rawMenuItems.map((item) =>
    item.path === "logout" ? { ...item, action: modalLogout } : item
  );

  return (
    <IonPage  id="main-content">
      <HeaderApp />
      <IonContent>
        <IonActionSheet
          isOpen={actionSheetNumero}
          header={`Deseja realmente sair da conta atual?`}
          buttons={[
            {
              text: "Sim",
              role: "destructive",
              handler: () => logout(),
            },
            {
              text: "Fechar",
              role: "cancel",
              handler: () => {
                return;
              },
            },
          ]}
          onDidDismiss={() => setActionSheetNumero(false)}
        ></IonActionSheet>
        <IonList>
          {menuItems.map(({ path, icon, label, action }) => (
            <IonItem
              key={path}
              button
              onClick={() => (action ? action() : navigate(path))}
            >
              <IonLabel>
                <i className={icon}></i> &nbsp; {label}
              </IonLabel>
            </IonItem>
          ))}
        </IonList>
        <MenuSide />
      </IonContent>
    </IonPage>
  );
}
